import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
import { SUBJECT_LIST_QUERY } from './getList';
const CREATE_SUBJECT_MUTATION = gql `
  mutation EP_CreateSubject(
    $examLevelID: ID!
    $type: Int!
    $data: EPSubjectCreateInput!
  ) {
    ep_createSubject(examLevelID: $examLevelID, type: $type, data: $data) {
      id
      data {
        title
        description
      }
      type
      attributes {
        totalQuestionCount
        answeredQuestionCount
      }
    }
  }
`;
export function useCreateSubjectMutation(options) {
    return useGQLMutation(CREATE_SUBJECT_MUTATION, {
        animateOnSuccess: true,
        ...options,
        update(cache, { data }, { variables }) {
            if (!data?.ep_createSubject || !variables) {
                return;
            }
            cache.updateQuery({
                query: SUBJECT_LIST_QUERY,
                variables: {
                    examLevelID: variables.examLevelID,
                    type: variables.type,
                    pagination: {
                        offset: 0,
                        limit: 50,
                    },
                },
            }, ({ ep_subjectList: existingData }) => ({
                ep_subjectList: {
                    ...existingData,
                    totalCount: existingData.totalCount + 1,
                    // New subjects get max sequence + 1, so they belong at the end.
                    list: [
                        ...existingData.list,
                        {
                            ...data.ep_createSubject,
                            __typename: 'EPSubject',
                        },
                    ],
                },
            }));
        },
    });
}
